module.exports = __webpack_public_path__ + "img/infoContent-bg001.69c56da.webp";